module.exports = __webpack_public_path__ + "fonts/iconfont.202609df.ttf";